import React, { useEffect, useState } from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip,
} from "@material-ui/core";
import useStyles from "../../styles";

const states = {
  sent: "success",
  pending: "warning",
  declined: "secondary",
};

export default function TableComponent({ data }) {
  const classes = useStyles();
  var keys = Object.keys(data[0]).map((i) => i.toUpperCase());
  keys.shift(); // delete "id" key
  // const [posts, setPosts] = useState([]);
  const posts = {
    posts: [
      {
        id: 0,
        name: "محمد رضایی",
        email: "mohammad@gmail.com",
        product: "لپتاپ",
        price: "20000000",
        date: "1401/05/02",
        city: "تهران",
        status: "sent",
      },
      {
        id: 1,
        name: "رضا باباخانی",
        email: "reza@gmail.com",
        product: "لپتاپ",
        price: "40000000",
        date: "1401/05/03",
        city: "تهران",
        status: "sent",
      },
      {
        id: 2,
        name: "میلاد کنعانی",
        email: "milad@gmail.com",
        product: "لپتاپ",
        price: "50000000",
        date: "1401/04/02",
        city: "تهران",
        status: "pending",
      },
      {
        id: 3,
        name: "ترانه علیمردانی",
        email: "taraneh@gmail.com",
        product: "لپتاپ",
        price: "30000000",
        date: "1401/03/02",
        city: "تهران",
        status: "declined",
      },
      {
        id: 4,
        name: "حامد محمدی",
        email: "hamed@gmail.com",
        product: "لپتاپ",
        price: "60000000",
        date: "1401/04/02",
        city: "تهران",
        status: "sent",
      },
      {
        id: 5,
        name: "محسن حصارکی",
        email: "mohsen@gmail.com",
        product: "لپتاپ",
        price: "60000000",
        date: "1401/04/08",
        city: "تهران",
        status: "sent",
      },
    ],
  };
  //fetch data
  // useEffect(() => {
  //   fetch("http://localhost:3000/posts/")
  //     .then((response) => response.json())
  //     .then((json) => setPosts(json));
  // }, []);
  function separate(Number) {
    Number += "";
    Number = Number.replace(",", "");
    let x = Number.split(".");
    let y = x[0];
    let z = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    const i = "$1,$2";
    while (rgx.test(y)) y = y.replace(rgx, i);
    return y + z;
  }
  return (
    <Table className="mb-0">
      <TableHead>
        <TableRow>
          {keys.map((key) => (
            <TableCell style={{ textAlign: "center" }} key={key}>
              {key}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {posts.posts.map(
          ({ id, name, email, product, price, date, city, status }) => (
            <TableRow key={id}>
              <TableCell className="pl-3 fw-normal">{name}</TableCell>
              <TableCell>{email}</TableCell>
              <TableCell>{product}</TableCell>
              <TableCell>{separate(price)}</TableCell>
              <TableCell>{date}</TableCell>
              <TableCell>{city}</TableCell>
              <TableCell>
                <Chip
                  label={status}
                  classes={{ root: classes[states[status.toLowerCase()]] }}
                />
              </TableCell>
            </TableRow>
          ),
        )}
      </TableBody>
    </Table>
  );
}
